/* Utilities for react-draft-wysiwyg-editor */

import { ContentState, convertToRaw, EditorState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import htmlToDraft from 'html-to-draftjs';

export const convertEditorDataToHtml = (data: EditorState) => {
    return draftToHtml(convertToRaw(data.getCurrentContent()));
};

export const getEditorStateFromHtmlString = (htmlContentAsString: string) => {
    if (!htmlContentAsString) {
        return EditorState.createEmpty();
    }

    const contentBlock = htmlToDraft(htmlContentAsString);
    if (!contentBlock) {
        return EditorState.createEmpty();
    }

    const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
    );
    const editorState = EditorState.createWithContent(contentState);

    return editorState;
};
